export default __webpack_public_path__ + "static/media/i-connect.f63732f7.svg";